const moduleOrder = [
  'dashboard',
  'news',
  'gallery-folders',
  'voting',
  'feedback-suggestions',
  'master-data',
  'news-archieve',
  'gallery-folders-archieve',
  'voting-archieve',
  'forums-archieve',
  'user-role',
  'config-landing'
]
export default moduleOrder



// WEBPACK FOOTER //
// ./src/modules/_order.js